import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import ProductManagementCreateForm from '../../components/forms/product-management/create.form';
import ProductSliderEdit from '../../components/forms/product-management/edit.form';
import NutritionStandardsManagement from '../health-consulting-management/nutrition-standards-management';
import NutritionStandardImport from '@/components/tables/nutrition-standards-management/nutrition-standards-import.table';

export default function NutritionStandardsManagementSlider() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case PermissionMode.CREATE:
        return <ProductManagementCreateForm />;
      case PermissionMode.EDIT:
        return <ProductSliderEdit />;
      case PermissionMode.CREATE_BY_LIST:
        return <NutritionStandardImport />;
      default:
        return <NutritionStandardsManagement />;
    }
  };
  return <>{renderContent()}</>;
}
